module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEySURBVFhH7ZVrEoMgDISxh9Uz6WVt1gkWIyEQ6ONHv5mM0CnsJrym0MC6rjs3syzL0jQfMAekovM8cyvPtm3cqjej/ikKW6Ia0YynKof4KKxlu1EjHsI1LGhahI1HPIYFTY/QqS27FI5RA8kg7rSuuUc8QnKIkwd/m5AWWrlszNbsR0Cy5+loqsBEJ1oLL00GvCXXQBVce2AkfwPfN4DXKn1G381ER4Y2H/d+ZQk+VQWZPXTlFcIXVZ6aC0cbLsVBzgAomvCgieOr5TTMREkclIp6OPAagTAoiYOSAQzeaQD3bDNRFEhhIMVB0QCACW5iAm7dzeRKnZITB6aBSGoEwExqQjOgCXfBZkj/Bfr4XRq1cN2EnBUl3Z9c71XcbWLEW9BlYtRjNOU2YA2jDDh3ewhPOwGelnvg0EoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/INFO.png
// module id = 83
// module chunks = 0